var _path, _path2, _circle, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddchild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.8 21.8H8.5c-1.6 0-2.8-1.3-2.8-2.8v-3.2C5.7 14.2 7 13 8.5 13h8.3V4.6c0-1.6 1.3-2.8 2.8-2.8h3.2c1.6 0 2.8 1.3 2.8 2.8v8.3H34c1.6 0 2.8 1.3 2.8 2.8v3.2c0 1.6-1.3 2.8-2.8 2.8h-8.3v6c0 1.6-1.3 2.8-2.8 2.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.8 21.8H8.5c-1.6 0-2.8-1.3-2.8-2.8v-3.2C5.7 14.2 7 13 8.5 13h8.3V4.6c0-1.6 1.3-2.8 2.8-2.8h3.2c1.6 0 2.8 1.3 2.8 2.8v8.3H34c1.6 0 2.8 1.3 2.8 2.8v3.2c0 1.6-1.3 2.8-2.8 2.8h-8.3v6c0 1.6-1.3 2.8-2.8 2.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.3,
    cy: 17.3,
    r: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M30 32l4.4 4.4-4.4 4.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M16.8 21.8v14.6h15.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M30 32l4.4 4.4-4.4 4.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M16.8 21.8v14.6h15.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddchild);
export default __webpack_public_path__ + "static/media/addchild.044cc75ce588113ae7129112394e7848.svg";
export { ForwardRef as ReactComponent };